<template>
  <div class="bill-sign">
    <div class="card userInfo" v-if="token">
      <div class="item">
        <span class="left">发票签收人</span>
        <span class="right">{{ name }}</span>
      </div>
      <div class="item">
        <span class="left">签收人手机号</span>
        <span class="right">{{ mobile | dealMobile }}</span>
      </div>
    </div>

    <div class="card userInfo" v-else>
      <div class="item">
        <span class="left">发票签收人</span>
        <input class="input" v-model="name" type="text" placeholder="请输入姓名" />
      </div>
      <div class="item">
        <span class="left">签收人手机号</span>
        <input class="input" :value="formatMobile" type="tel" maxlength="13" placeholder="请输入手机号" @input="handleMobile" />
      </div>
      <div class="item">
        <span class="left">验证码</span>
        <div class="verifyCode">
          <input class="input" v-model="verifyCode" type="tel" maxlength="6" placeholder="请输入验证码" />
          <button class="btn active" @click="getVerifyCode" v-if="seconds <= 0">
            获取验证码
          </button>
          <button v-else class="btn no-active">{{ seconds }}S</button>
        </div>
      </div>
    </div>

    <div class="card notice">
      共<span class="number">{{ total }}</span>张发票需要签收
    </div>

    <van-list v-model="listloading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="card bill-info" v-for="item in billList" :key="item.invoicedSid">
        <div class="bill-title">
          <div class="name">{{ item.buyerBrandName }}</div>
          <div class="total">
            <span>(含税)</span>
            <span>¥{{ item.invoicedMoney }}</span>
          </div>
        </div>

        <div class="bill-form" v-if="sourceType == 1">
          <div class="form-item"></div>
          <div class="label">销方名称：</div>
          <div class="value">{{ item.plazaname }}</div>
        </div>
        <div class="bill-form height">
          <div class="label">发票类型：</div>
          <div class="value">
            {{ sourceType == 1 ? typeCode[item.typeCode] : item.invoiceType }}
          </div>
        </div>
        <div class="bill-form height">
          <div class="label">发票代码：</div>
          <div class="value value-num">{{ item.invoicedCode }}</div>
        </div>
        <div class="bill-form height">
          <div class="label">发票号码：</div>
          <div class="value value-num">{{ item.invoicedSid }}</div>
        </div>

        <div class="date">
          <div class="label">开票日期：</div>
          <div class="time">{{ item.createDate }}</div>
        </div>
      </div>
    </van-list>

    <div class="footer">
      <van-button class="submit" round :loading="loading" loading-text="签收中..."
        color="#FF6F00" @click="submit">
        发票签收
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  apiGetVerifyCode,
  apiGetVerifyValid,
  apiGetBillList,
  apiBillSign,
} from '@/api/billSign.js';
import { Field, Toast, List } from 'vant';
const mobileReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

const typeCode = {
  '004': '专票',
  '026': '电子发票',
  '007': '普票',
  '028': '电子专票',
};


export default {
  comments: {
    VanField: Field,
    VanList: List,
  },
  computed: {
    batchNo() {
      return this.$route.query.batchId;
    },
    sourceType() {
      return this.$route.query.sourceType;
    },
    token() {
      return this.$route.query.token;
    },
    isWechat() {
      return (
        String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
        'micromessenger'
      );
    }

  },

  data() {
    return {
      name: '',
      formatMobile: '',
      mobile: '',
      verifyCode: '',
      seconds: 0,
      loading: false,
      pageNum: 1,
      pageSize: 10,
      billList: [],
      total: 0,
      listloading: false,
      finished: false,
      typeCode
    };
  },
  filters: {
    dealMobile(mobile) {
      return `${mobile.slice(0, 3)}****${mobile.slice(7)}`;
    },
  },
  methods: {
    onLoad() {
      let data = {
        batchNo: this.batchNo,
        sourceType: this.sourceType,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      apiGetBillList(data).then(res => {
        console.log(res);
        this.billList = this.billList.concat(res.items);
        this.total = res.totalCount;
        this.pageNum++;
        this.listloading = false;
        if (this.billList.length >= this.total) {
          this.finished = true;
        }
      }).catch(err => {
        this.finished = true;
        Toast.fail({
          className: 'billSign-fail',
          message: err.message,
          forbidClick: true,
          overlay: true,
          duration: 0
        })


      })
    },
    async submit() {
      if (!this.token) {
        if (!this.name) {
          return Toast.fail('签收人不能为空');
        }
        if (!this.mobile) {
          return Toast.fail('手机号不能为空');
        }
        if (!this.verifyCode) {
          return Toast.fail('验证码不能为空');
        }
        if (!mobileReg.test(this.mobile)) {
          return Toast.fail('手机号格式错误');
        }

        let data1 = {
          mobile: this.mobile,
          verifyCode: this.verifyCode,
        };
        let res1 = await apiGetVerifyValid(data1);
        if (res1.status != 200) {
          Toast.fail(res1.message);
          this.loading = false;
          return;
        }
      }
      this.loading = true;
      let data2 = {
        batchNo: this.batchNo,
        signer: this.name,
        signerMobile: this.mobile,
      };
      if (this.token) {
        data2.signSource = 1
      } else if (this.isWechat) {
        data2.signSource = 2
      } else {
        data2.signSource = 3
      }

      apiBillSign(data2).then(() => {
        Toast.success('签收成功');
        setTimeout(() => {
          this.loading = false;
          this.$router.replace({
            path: '/billSign_success',
          });
        }, 1500);
      });
    },
    getVerifyCode() {
      if (!this.mobile) {
        return Toast.fail('手机号不能为空');
      }
      if (!mobileReg.test(this.mobile)) {
        return Toast.fail('手机号格式错误');
      }
      apiGetVerifyCode(this.mobile).then(() => {
        this.seconds = 60;
        let timer = setInterval(() => {
          this.seconds--;
          if (this.seconds <= 0) {
            this.seconds == 0;
            clearInterval(timer);
          }
        }, 1000);
      });
    },
    handleMobile(e) {
      let value = e.target.value.split(' ').join('');
      this.mobile = value;
      this.formatMobile = [
        value.slice(0, 3),
        value.slice(3, 7),
        value.slice(7),
      ].join(' ');
    },
  },
  mounted() {
    if (this.token) {
      this.$bsUtils.nativeApi.getUserInfo().then(res => {
        this.name = res.name;
        this.mobile = res.mobile;
      });
    }
  },
};
</script>

<style lang="less" scoped>
.bill-sign {
  line-height: 1;
  text-align: left;
  background-color: #f4f4f4;
  padding: 10px;
  box-sizing: border-box;
  font-family: PingFangSC-Medium, PingFang SC;
  overflow: auto;
  padding-bottom: 120px;

  .userInfo {
    font-size: 14px;
    font-weight: 400;

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #e7e7e7;
      padding: 16px 0;

      .left {
        color: #666666;
        flex-shrink: 0;
      }

      .right {
        color: #111111;
      }

      .input {
        border: none;
        text-align: right;
        font-size: 14px;
      }

      .input::placeholder {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }

      .verifyCode {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
      }

      .btn {
        padding: 6px 0;
        border-radius: 16px;
        margin-left: 12px;
        background-color: #ffffff;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        width: 84px;
      }

      .no-active {
        border: 1px solid #999999;
        color: #999999;
      }

      .active {
        flex-shrink: 0;
        border: 1px solid #FF6F00;
        color: #FF6F00;
      }

    }

    .item:first-child {
      border: none;
      padding-top: 0;
    }

    .item:last-child {
      padding-bottom: 0;
    }
  }

  .notice {
    font-size: 14px;
    font-weight: 400;
    color: #fc9127;
    background-color: #fff9f2;
    text-align: center;

    span {
      margin: 0 1px;
    }
  }

  .bill-info {
    .bill-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;

      .name {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        margin-right: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .total {
        font-size: 16px;
        font-weight: 400;
        flex-shrink: 0;

        span:nth-child(1) {
          font-size: 12px;
          color: #999999;
        }

        span:nth-child(2) {
          margin-left: 4px;
          font-size: 16px;
          color: #FF6F00;
        }
      }
    }

    .bill-form {
      display: flex;
      margin-bottom: 5px;

      .label {
        font-size: 14px;
        font-weight: 400;
        color: #ababab;
      }

      .value {
        margin-left: 8px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
      }

      .value-num {
        color: #666666;
      }
    }

    .height {
      margin-bottom: 12px;
    }

    .date {
      font-size: 12px;
      font-weight: 400;
      color: #ababab;
      display: flex;
      border-top: 1px solid #e4e4e4;
      padding-top: 12px;

      .time {
        margin-left: 4px;
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    box-sizing: border-box;
    padding: 12px 12px 30px 12px;
    background-color: #f4f4f4;

    .submit {
      width: 100%;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
    }
  }
}

.card {
  background: #ffffff;
  border-radius: 8px;
  padding: 14px;
  box-sizing: border-box;
  margin-top: 12px;
}
</style>
